import { Box, Stack, Typography } from "@mui/material";
import LogoVnpost from "components/logo-vnpost/LogoVnpost";
import { Link } from "react-router-dom";

const NoPermission = ({ backLink }) => {
  return (
    <Box pt={10} display="flex" justifyContent="center">
      <Stack spacing={2} alignItems="center">
        <LogoVnpost />
        <Typography color={(theme) => theme.palette.error.main}>
          Không có quyền truy cập trang này!
        </Typography>
        <Link to={backLink || process.env.REACT_APP_PATH}>
          <Typography>Quay lại</Typography>
        </Link>
      </Stack>
    </Box>
  );
};

export default NoPermission;
